<template>
  <div>
    <b-row>
      <b-col :sm="12">
        <h1 class="page-title section-title">
          {{ invoice.reference }}
          <span class="subtitle title-slash"
            >- {{ $t('invoices.upload.subtitle') }}</span
          >
        </h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col :xl="7" v-if="!loading">
        <div v-for="task in uploadTasks" :key="task.id">
          <div
            class="doc-upload-container"
            v-for="uploadDoc in task.upload_docs"
            :key="uploadDoc.key"
          >
            <file-upload
              :task="task"
              @added="uploadInProgress++"
              @complete="uploadInProgress--"
              @success="success(task)"
              :uploadDoc="uploadDoc"
            />
          </div>
        </div>
        <p class="file-upload-outro lead">
          {{ $t('invoices.upload.addInvoice') }}
        </p>
        <b-row>
          <b-col :lg="6">
            <b-button
              variant="primary"
              block
              @click="done(true)"
              class="upload-cta"
              :disabled="uploadInProgress !== 0"
              v-track-click
              id="invoices-upload-save-new"
            >
              {{ $t('invoices.upload.saveUpload') }}
            </b-button>
          </b-col>
          <b-col :lg="6">
            <b-button
              variant="primary"
              block
              @click="done(false)"
              class="upload-cta"
              :disabled="uploadInProgress !== 0"
              v-track-click
              id="invoices-upload-proceed"
            >
              {{
                isDone && canEsign
                  ? $t('invoices.upload.noSaveProceedEsign')
                  : $t('invoices.upload.noSaveProceed')
              }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <div class="col-sm-12" v-else>
        <loader :height="200" />
      </div>
    </b-row>
    <b-modal ref="confirmModal" :hide-footer="true" class="confirm-modal">
      <p class="confirm-modal-text lead">
        {{ $t('invoices.upload.proceed') }}
      </p>
      <b-button
        variant="primary mr-2"
        @click="viewInvoice"
        v-track-click
        id="invoices-upload-later"
      >
        {{ $t('invoices.upload.uploadLater') }}
      </b-button>
      <b-button variant="secondary mr-2">
        {{ $t('invoices.upload.continue') }}
      </b-button>
    </b-modal>
    <b-modal ref="confirmModalAdd" :hide-footer="true" class="confirm-modal">
      <p class="confirm-modal-text lead">
        {{ $t('invoices.upload.proceed') }}
      </p>
      <b-button
        variant="primary mr-2"
        @click="newInvoice"
        v-track-click
        id="invoices-upload-later"
        >{{ $t('invoices.upload.uploadLater') }}</b-button
      >
      <b-button
        variant="secondary mr-2"
        v-track-click
        id="invoices-continue-uploading"
        >{{ $t('invoices.upload.continue') }}</b-button
      >
    </b-modal>
  </div>
</template>
<script>
import Loader from '@/components/common/Loader'
import FileUpload from '@/components/invoices/FileUpload'
import moment from 'moment'
import { freshdeskMixin } from '@/mixins/Freshdesk'
import invoiceService from '@/services/invoice'

export default {
  data() {
    return {
      loading: false,
      invoice: {},
      uploadInProgress: 0,
      // todo: don't use state
      newInvoiceRequested: false
    }
  },
  mounted() {
    document.title = `${this.invoice?.reference} | Invoices | Drip Portal`
    this.loadInvoice()
    if (this.$store.state.account.country === 'India') {
      this.showAndPrefillFreshdesk({ cf_category_i: 'Invoice related' })
    }
  },
  computed: {
    exporter() {
      return this.$store.getters.user.linked_users.find((exporter) => {
        return exporter.id === parseInt(this.$store.state.account.accountId)
      })
    },
    canEsign() {
      return this.exporter.parent_user_permissions['aadhar_esign_allowed?']
    },
    uploadTasks() {
      if (!this.invoice.task_flows) {
        return []
      }
      return this.invoice.task_flows.filter((task) => {
        const regex = new RegExp(this.invoice.doc_set_2.join('|'), 'gi')
        const except =
          this.invoice.doc_set_2.length > 0 && task.uid.match(regex)
        return task.uid.indexOf('upload_') > -1 && !except
      })
    },
    isDone() {
      if (!this.invoice.task_flows) {
        return true
      }
      return (
        this.invoice.task_flows.filter(
          (task) =>
            task.uid.indexOf('upload_') > -1 && task.status === 'pending'
        ).length === 0
      )
    }
  },
  methods: {
    success(task) {
      task.status = 'done'
    },
    done(newInvoice) {
      if (this.isDone) {
        this.showWarning()
        if (newInvoice) {
          return this.newInvoice()
        } else if (this.canEsign) {
          return this.showEsign()
        } else {
          return this.viewInvoice()
        }
      } else {
        if (newInvoice) {
          return this.$refs.confirmModalAdd.show()
        } else {
          return this.$refs.confirmModal.show()
        }
      }
    },
    showEsign() {
      return this.$router.push({
        name: 'invoicesEsign'
      })
    },
    viewInvoice() {
      return this.$router.push({
        name: 'invoicesSingle',
        params: {
          id: this.invoice.id
        }
      })
    },
    newInvoice() {
      return this.$router.push({
        name: 'invoicesAdd'
      })
    },
    showWarning() {
      if (moment() > this.$store.state.constants.lateTime && !this.canEsign) {
        this.$notify({
          title: this.$t('invoices.warnings.late.title'),
          text: this.$t('invoices.warnings.late.text'),
          type: 'warn',
          duration: -1
        })
      }
    },
    loadInvoice(skipLoading) {
      invoiceService
        .fetchInvoicesById(this.$route.params.id, {
          include: ['docs_tagged', 'task_flows']
        })
        .then((res) => {
          this.loading = false
          this.invoice = res.data
        })
    }
  },
  components: {
    Loader,
    FileUpload
  },
  mixins: [freshdeskMixin]
}
</script>
<style lang="scss">
.upload-cta {
  margin-bottom: 1rem;
}

.confirm-modal {
  .modal-dialog {
    width: 720px;
    max-width: 100%;
    .modal-body {
      padding: 1.67rem;
    }
  }
}
</style>
